export default __webpack_public_path__ + "media/images/icons/credit-card-solid-99dc95950163f8e39c958be5d850811a.svg";